import { render, staticRenderFns } from "./Wiki.vue?vue&type=template&id=d3a9c362"
import script from "./Wiki.vue?vue&type=script&lang=js"
export * from "./Wiki.vue?vue&type=script&lang=js"
import style0 from "./Wiki.vue?vue&type=style&index=0&id=d3a9c362&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports